// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__nfk7F","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__14Nd8"};